import { Component, EventEmitter, OnInit, Output } from '@angular/core'

@Component({
  selector: 'app-connect-agoda-wizard-step1',
  templateUrl: './connect-agoda-wizard-step1.component.html',
  styleUrls: ['./connect-agoda-wizard-step1.component.scss'],
})
export class ConnectAgodaWizardStep1Component implements OnInit {
  @Output() next = new EventEmitter()
  constructor() {}

  ngOnInit(): void {}
}
